import { type ReactNode } from 'react';
import * as React from 'react';
import { rgba } from 'polished';
import styled from 'styled-components';

import { CloseIcon } from '../../icons/Icons';

import { Button } from '.';

const ModalWrapper = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999999;

  ${({ $isOpen }) => ($isOpen ? 'display: block;' : 'display: none;')};
`;

const ModalInner = styled.div<{ $maxWidth: number }>`
  position: fixed;
  background: ${({ theme }) => theme.colors.BLACK};
  border: 1px solid ${({ theme }) => theme.borderColor.DEFAULT};
  box-shadow:
    0 4px 4px ${({ theme }) => rgba(theme.colors.BLACK, 0.25)},
    0 0 54px ${({ theme }) => theme.colors.BLACK},
    0 0 50px ${({ theme }) => rgba(theme.borderColor.DEFAULT, 0.25)};
  width: 80%;
  height: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  min-height: 250px;
  padding: 60px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.SMALL}) {
    padding: 40px 30px;
  }

  ${({ $maxWidth }) => $maxWidth && `max-width: ${$maxWidth}px`};
`;

const ModalBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: ${({ theme }) => rgba(theme.colors.BLACK, 0.6)};
`;

const ModalBody = styled.div``;

const CloseButton = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
`;

interface ModalProps {
  children: ReactNode;
  className?: string;
  isOpen: boolean;
  maxWidth?: number;
  onClose: () => void;
}

export const Modal: React.ComponentType<ModalProps> = React.memo(
  ({ children, className, onClose, isOpen, maxWidth = 600 }) => {
    return (
      <ModalWrapper $isOpen={isOpen} className={className}>
        <ModalInner $maxWidth={maxWidth}>
          <CloseButton>
            <Button
              icon={<CloseIcon />}
              size="small"
              stylez="minimal"
              onClick={onClose}
            />
          </CloseButton>
          <ModalBody>{children}</ModalBody>
        </ModalInner>
        <ModalBackground onClick={onClose} />
      </ModalWrapper>
    );
  }
);
